<template>
  <v-container grid-list-md>
    <v-row>
      <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2">
        <v-card>
          <v-toolbar>
            <v-toolbar-title>Theatre Shows</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-if="isAdmin" v-model="newShowDialog" width="400">
              <template #activator="{ on }">
                <v-btn v-on="on">Add Show</v-btn>
              </template>
              <v-card>
                <v-card-title>Add Show</v-card-title>
                <v-card-text>
                  <v-text-field v-model="newShowName" label="Name of Show" outlined />
                  <v-text-field v-model="newShowShortName" label="Short Name (for URL Link; must be unique)" outlined />
                </v-card-text>
                <v-card-actions>
                  <v-btn :disabled="!newShowValid" color="primary" text @click="createNewShow()">Create New Show</v-btn>
                  <v-spacer />
                  <v-btn text @click="newShowDialog = false">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-list>
            <v-list-item v-for="{ name, shortName, performances, firstDate, lastDate } in shows" :key="`show-${shortName}`" :to="'/theatre/' + shortName" dense>
              <v-list-item-content>
                <v-list-item-title class="mb-2" style="font-size:1.2rem">{{ name }}</v-list-item-title>
                <v-list-item-subtitle v-if="performances === 0" style="white-space:normal">Performance dates not set</v-list-item-subtitle>
                <v-list-item-subtitle v-else-if="firstDate && lastDate && firstDate !== lastDate" style="white-space:normal">
                  {{ performances }} Performances {{ firstDate }} through {{ lastDate }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else style="white-space:normal">
                  {{ performances }} Performance{{ performances === 1 ? '' : 's' }} on {{ firstDate }} only
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { ref, computed, watch, onMounted } from '@vue/composition-api'

export default {
  setup (props, { root }) {
    const user = computed(() => 'spoof' in root.$store.state.user ? root.$store.state.user.spoof : root.$store.state.user)
    const isAdmin = computed(() => root.$store.state.loggedIn && user.value.roles.includes('Technology Services'))
    const shows = ref([])
    const isLoaded = ref(false)

    onMounted(async () => {
      let query = {
        active: true,
        $and: [{
          $or: [{ openDate: { $lte: new Date() } }, { openDate: { $exists: false } }]
        }, {
          $or: [{ closeDate: { $gte: new Date() } }, { closeDate: { $exists: false } }]
        }, {
          'shows.date': { $gte: new Date() }
        }],
        $limit: 50
      }
      const { data } = await root.$feathers.service('theatre/show').find({ query })
      shows.value = data.map((row) => {
        const show = { name: row.name, shortName: row.shortName, performances: 0, soldOut: false, firstDate: '', lastDate: '' }
        const showsWithSeatsLeft = row.performances.filter(({ tickets, reserved }) => tickets > reserved)
        if (showsWithSeatsLeft.length === 0) {
          show.soldOut = true
        }
        if (row.performances.length > 0) {
          show.performances = row.performances.length
          let firstDate = new Date(row.performances[0].date)
          let lastDate = new Date(firstDate)
          row.performances.forEach(({ date }) => {
            const dt = new Date()
            if (dt < firstDate) firstDate = dt
            if (dt > lastDate) lastDate = dt
          })
          show.firstDate = firstDate.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' })
          show.lastDate = lastDate.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' })
        }
        return show
      })
    })

    const newShowDialog = ref(false)
    const newShowName = ref('')
    const newShowShortName = ref('')
    const newShowValid = ref(false)

    watch([newShowName, newShowShortName], async () => {
      if (!isLoaded.value) return
      console.log('Dialog value changed')
      if (!newShowName.value) {
        console.log(`New Show Name is invalid: ${newShowName.value}`)
        newShowValid.value = false
      }
      if (!newShowShortName.value) {
        console.log(`New Show Short Name is invalid: ${newShowShortName.value}`)
        newShowValid.value = false
      } else {
        console.log('Checking for other shows with the same short name')
        const { total } = await root.$feathers.service('theatre/show').find({ query: { $or: [{ closeDate: null }, { closeDate: { $exists: false } }, { closeDate: { $gte: new Date() } }], shortName: newShowShortName.value, $limit: 0 } })
        newShowValid.value = (total === 0)
      }
    })

    async function createNewShow () {
      if (newShowValid.value) {
        const obj = {
          name: newShowName.value,
          shortName: newShowShortName.value
        }
        const res = await root.$feathers.service('theatre/show').create(obj)
        if (res) {
          root.$router.push('/theatre/' + res.shortName)
        }
      }
    }

    return {
      isAdmin,
      shows,
      newShowDialog,
      newShowName,
      newShowShortName,
      newShowValid,
      createNewShow
    }
  }
}
</script>
